import { getCommercialOrderConfirmWithProduct, getResearchOrderConfirmWithProduct, } from "../api/generated/wrappers/order";
import { getCommercialOrderConfirm, getResearchOrderConfirm, } from "../api/generated/wrappers/order";
import { getCommercialOrderProductDetail, getResearchOrderProductDetail, } from "../api/generated/wrappers/order";
import { getCommercialProductsForInbound, getResearchProductsForInbound, } from "../api/generated/wrappers/order";
import { createQueryKeys } from "./create-query-keys";
const orderQueryKeys = createQueryKeys("order", {
    confirmWithProduct: (isCommercial, id) => ({
        queryKey: ["confirmWithProduct", isCommercial, id],
        queryFn: async () => isCommercial
            ? await getCommercialOrderConfirmWithProduct(id)
            : await getResearchOrderConfirmWithProduct(id),
    }),
    confirm: (isCommercial, params) => ({
        queryKey: ["confirm", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialOrderConfirm(params)
            : await getResearchOrderConfirm(params),
    }),
    product: (isCommercial, orderId) => ({
        queryKey: ["product", isCommercial, orderId],
        queryFn: async () => isCommercial
            ? await getCommercialOrderProductDetail(orderId)
            : await getResearchOrderProductDetail(orderId),
    }),
    productsForInbound: (isCommercial, orderId) => ({
        queryKey: ["productsForInbound", isCommercial, orderId],
        queryFn: async () => isCommercial
            ? await getCommercialProductsForInbound(orderId)
            : await getResearchProductsForInbound(orderId),
    }),
});
export default orderQueryKeys;
